import * as t from 'io-ts';
import { isUndefined } from 'lodash-es';

import type { TextInputDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface TitleSettingDefinition extends TextInputDefinition {
    key: 'TITLE';
}

const definition: TitleSettingDefinition = {
    key: 'TITLE',
    label: 'Title',
    type: 'TextInput',
    value: '',
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.string);

export const codec = specSettingsInterface.input;

export const TitleSettingDefinition = define({
    key: 'TITLE',
    label: 'title',
    definition,
    fromSetting: (settings, _, view) => {
        return specSettingsInterface.extractValue(settings.title) || (view ? undefined : '');
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        isUndefined(settings.title)
            ? // even if setting is not defined, we still want it to be available
              definition
            : specSettingsInterface.createDefinitionWithSettings(settings.title),
});
